// Reusable status dot used by avatars across the app. Colors
// stay consistent across profile, member-list, and direct-message surfaces.

import { cn } from "@link/ui";

import type { FriendStatus } from "../types/ui";

export const STATUS_DOT_BG: Record<FriendStatus, string> = {
  online: "bg-emerald-400",
  away: "bg-amber-400",
  busy: "bg-red-400",
  offline: "bg-cloud-300",
};

export const STATUS_LABEL: Record<FriendStatus, string> = {
  online: "Online",
  away: "Away",
  busy: "Do not disturb",
  offline: "Offline",
};

interface Props {
  status: FriendStatus;
  /** Optional ring color override. White is correct on light bg; pass `ring-cloud-700` over the dark profile modal. */
  ringClass?: string;
  /** Tailwind class controlling the dot diameter. Default `h-3 w-3`. */
  sizeClass?: string;
  className?: string;
}

export function StatusDot({
  status,
  ringClass = "ring-white",
  sizeClass = "h-3 w-3",
  className,
}: Props) {
  return (
    <span
      className={cn(
        "block rounded-full ring-2",
        sizeClass,
        ringClass,
        STATUS_DOT_BG[status],
        className,
      )}
    />
  );
}
